<template>
    <dialog-box v-if="value" @close="$emit('input', false)" width="500px"
                title="Edit Clickatell WhatsApp credentials">
        <div>
            <p>Rotate the credentials and/or phone for <strong>{{ profile.handle }}</strong>.</p>

            <clickatell-credentials-form v-model="creds" @valid="v => valid = v" />

            <div v-if="error" class="row-fluid">
                <div class="span12">
                    <div class="alert">{{ error }}</div>
                </div>
            </div>
        </div>
        <template #buttons>
            <a class="btn cancel" @click="$emit('input', false)">Cancel</a>
            <a class="btn btn-primary" @click="ok" :class="{disabled: saving || !valid}">
                <span v-if="saving" class="spinner"/>
                <span v-else>Save</span>
            </a>
        </template>
    </dialog-box>
</template>

<script>
import DialogBox from "@/components/DialogBox";
import ClickatellCredentialsForm from "@/setup/profiles/add-profile/whatsapp/ClickatellCredentialsForm";
import { mapActions } from "vuex";
import VuexStore from "@/store/vuex/VuexStore";

const CLICKATELL_APP_ID = 46;

export default {
    name: "EditClickatellCredentialsDialog",
    store: VuexStore,
    components: { DialogBox, ClickatellCredentialsForm },

    props: {
        value: Boolean,
        profile: { type: Object, required: true }
    },

    data() {
        return {
            creds: {
                integrationId: this.profile.token || "",
                apiKey: this.profile.tokenSecret || "",
                phone: this.profile.handleId || ""
            },
            valid: false,
            saving: false,
            error: null
        }
    },

    methods: {
        ...mapActions('profiles', ['updateProfile', 'refreshProfiles']),

        async ok() {
            if (this.saving || !this.valid) return;
            try {
                this.saving = true;
                this.error = null;

                let payload = {
                    id: this.profile.id,
                    type: this.profile.type,
                    name: this.profile.name,
                    handle: this.profile.handle,
                    handleId: this.creds.phone,
                    token: this.creds.integrationId,
                    tokenSecret: this.creds.apiKey,
                    apiAppId: CLICKATELL_APP_ID
                };

                await this.updateProfile(payload);
                await this.refreshProfiles(true);
                this.$emit('input', false);
            } catch (e) {
                console.error("Error updating Clickatell credentials: ", e);
                this.error = "Failed to update credentials. Please try again or contact DataEQ support.";
            } finally {
                this.saving = false;
            }
        }
    }
}
</script>
